import React from 'react';
import { TextLink } from 'ui-builder';

import styles from './PoliciesLinks.module.scss';

export default function PoliciesLinks() {
  return (
    <div className={styles.links}>
      <TextLink
        href="https://nekst.com"
        target="_blank"
        className={styles.link}
      >
        Home
      </TextLink>
      •
      <TextLink
        href="https://nekst.com/terms"
        target="_blank"
        className={styles.link}
      >
        Terms of Service
      </TextLink>
      •
      <TextLink
        href="https://nekst.com/privacy"
        target="_blank"
        className={styles.link}
      >
        Privacy Policy
      </TextLink>
    </div>
  );
}
